import { api } from 'shared';
import { z } from 'zod';

export const BestPortfolioEventsGroupResponseSchema = z.object({
    data: z.object({
        image: z.object({
            url: z.string(),
        }).optional().nullable(),
        events: z.array(
            z.object({
                documentId: z.string(),
                slug: z.string(),
                name: z.string(),
                description: z.any(),
                images: z.array(
                    z.object({
                        url: z.string(),
                    }),
                ).optional().nullable(),
            }),
        ).optional().nullable(),
    }),
});
export const fetchBestPortfolioEventsGroup = async () => (
    api.get<z.infer<typeof BestPortfolioEventsGroupResponseSchema>>(
        '/best-portfolio-events-group',
        {
            populate: {
                image: {
                    fields: 'url',
                },
                events: {
                    populate: {
                        images: {
                            fields: 'url',
                        },
                    },
                },
            },
        },
        BestPortfolioEventsGroupResponseSchema,
    )
);
